import {
  isAppLocale,
  LOCALE_TO_MANUS_THEME_LANG,
} from '@/constants/appLocale'

export const SAGAWA_DELIVERY_BOOKING_URL =
  'https://m.ctrip.com/webapp/xtaro-gshop/brand/branddetail?brandid=21098&share=1&wxpopup=207&inpopup=true&bid=12&pid=9&cid=2&s_guid=F7DA771B-C785-4ADC-9034-B5AC325DD302&csharecid=12001093290328287139'

export const SAGAWA_PRECAUTIONS_AND_FAQ_URL =
  'https://file.bilionpass.com/sagawa_luggage_service_customer_web_revised.html'

/** 注意事项 & FAQ 外链，携带 ?lang=（zh-CN / zh-TW / en / ja / ko） */
export const getSagawaPrecautionsAndFaqUrl = (language: string) => {
  const locale = isAppLocale(language) ? language : 'zh_CN'
  const url = new URL(SAGAWA_PRECAUTIONS_AND_FAQ_URL)
  url.searchParams.set('lang', LOCALE_TO_MANUS_THEME_LANG[locale])
  return url.toString()
}
